import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_BASE_URL = import.meta.env.VITE_DPH_PORTAL_API;

// Create a wrapper around fetchBaseQuery
const customBaseQuery: BaseQueryFn<
  FetchArgs,
  unknown,
  FetchBaseQueryError,
  object,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  // Get base query with our configuration
  const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
  });

  // Get state and token
  const state = api.getState() as AuthState;
  const token = state?.auth?.accessToken;

  // Add access_token as query param if available
  if (token && args.url) {
    // Convert params to object if it exists, or create new object
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const existingParams = (args.params as Record<string, any>) || {};
    // Only add token if not already present in params
    if (!('access_token' in existingParams)) {
      args.params = {
        ...existingParams,
        access_token: token,
      };
    }
  }

  // Forward to the original base query
  return baseQuery(args, api, extraOptions);
};

export default customBaseQuery;
